import React from 'react';

export default function ReadmeScreen() {
  return (
    <div style={{ padding: 20, maxHeight: '100vh', overflowY: 'auto' }}>
      <p style={{ marginTop: 10 }}>
        This is a waste locator app using React, TypeScript and MapLibre-GL to
        display mock waste container locations. Use the checkboxes to filter
        Paper and Glass containers.
      </p>
    </div>
  );
}
